import axios from "axios";
import { toast } from "react-hot-toast";
import { getApi } from "../backend";
import jwt_decode from "jwt-decode";

export const login = (data) => {
  return axios
    .post(`${getApi()}/api/v1/admin/login`, data)
    .then((res) => {
      if (res.data.success) {
        localStorage.setItem("token", JSON.stringify(res.data.data));
        toast.success(res.data.message, {
          position: "top-center",
        });
        window.location.href = "/dashboard";
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err.response.data.message);
      return err.response.data;
    });
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("token")) {
    return jwt_decode(JSON.parse(localStorage.getItem("token")));
  } else {
    return false;
  }
};

export const getStatistics = () => {
  return axios
    .get(`${getApi()}/api/v1/admin/statistics`)
    .then((res) => {
      console.log(res, "statistics");
      if (res.data.success) {
        return res.data.data;
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      return err.response.data;
    });
};

export const getAllUsers = () => {
  return axios
    .get(`${getApi()}/api/v1/admin/users`)
    .then((res) => {
      if (res.data.success) {
        return res.data.data;
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      return err.response.data;
    });
};
